// src/components/common/contentloader/ClusterSkeleton.jsx
import { Box, Card } from "@mui/material";
import { keyframes } from "@mui/system";

const shimmer = keyframes`
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
`;

const Sk = ({ w, h = 12, br = 6, mb = 0 }) => (
  <Box
    sx={{
      width: w,
      height: h,
      borderRadius: `${br}px`,
      mb: mb ? `${mb}px` : 0,
      background: "linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%)",
      backgroundSize: "600px 100%",
      animation: `${shimmer} 1.4s infinite`,
    }}
  />
);

const SkCard = ({ children, sx = {} }) => (
  <Card sx={{ boxShadow: "0 1px 3px 0 rgb(0 0 0/0.06)", border: "1px solid #e2e8f0", ...sx }}>
    <Box sx={{ p: "18px 20px" }}>{children}</Box>
  </Card>
);

export default function ClusterSkeleton() {
  return (
    <Box sx={{ p: 3, bgcolor: "#f5f7fa" }}>

      {/* Stat cards row */}
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 2, mb: 2.5 }}>
        {[90, 80, 100].map((w, i) => (
          <SkCard key={i}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Box>
                <Sk w={w} mb={10} />
                <Sk w={60} h={26} />
              </Box>
              <Sk w={42} h={42} br={10} />
            </Box>
          </SkCard>
        ))}
      </Box>

      {/* CPU / Memory + Pie row */}
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 2.5 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {["CPU Allocation", "Memory Allocation"].map((_, i) => (
            <SkCard key={i}>
              <Sk w={i === 0 ? 110 : 130} mb={14} />
              <Sk w="100%" h={8} br={20} mb={8} />
              <Sk w={80} />
            </SkCard>
          ))}
        </Box>
        <SkCard sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 2 }}>
          <Sk w={160} h={160} br={80} />
          <Box sx={{ display: "flex", gap: 1 }}>
            <Sk w={70} /><Sk w={70} /><Sk w={70} />
          </Box>
        </SkCard>
      </Box>

      {/* Header card */}
      <SkCard sx={{ mb: 2.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Sk w={46} h={46} br={12} />
          <Box><Sk w={180} h={16} mb={8} /><Sk w={120} /></Box>
        </Box>
      </SkCard>

      {/* Table skeleton */}
      <Card sx={{ border: "1px solid #e2e8f0" }}>
        <Box sx={{ p: "10px 18px", borderBottom: "1px solid #e2e8f0", display: "flex", gap: 4 }}>
          {[90, 50, 60, 70, 55].map((w, i) => <Sk key={i} w={w} h={10} />)}
        </Box>
        {[140, 120, 160].map((w, i) => (
          <Box key={i} sx={{ p: "14px 18px", borderBottom: i < 2 ? "1px solid #f1f5f9" : "none", display: "flex", gap: 4, alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 200 }}>
              <Sk w={36} h={36} br={9} />
              <Sk w={w} />
            </Box>
            <Sk w={80} />
            <Sk w={50} h={18} br={20} />
            <Sk w={100} h={7} br={20} />
            <Sk w={60} />
          </Box>
        ))}
      </Card>
    </Box>
  );
}